module.exports = __webpack_public_path__ + "img/bill-illustration.bdd9f847.svg";